module.exports = __webpack_public_path__ + "img/master.77c230a7.svg";